import React from 'react';

interface VideoPlayerProps {
  videoUrl?: string | null;
  title?: string;
  className?: string;
}

const extractWistiaId = (url: string): string | null => {
  const patterns = [
    /wistia\.net\/embed\/iframe\/([a-zA-Z0-9]+)/,
    /wistia\.com\/medias\/([a-zA-Z0-9]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) return match[1];
  }
  return null;
};

const isWistiaUrl = (url: string): boolean => {
  return url.includes('wistia');
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, title = 'video-player', className = '' }) => {
  const normalizedVideoUrl = videoUrl?.trim();

  if (!normalizedVideoUrl) {
    return null;
  }

  if (isWistiaUrl(normalizedVideoUrl)) {
    const wistiaId = extractWistiaId(normalizedVideoUrl);
    if (wistiaId) {
      const embedUrl = `https://fast.wistia.net/embed/iframe/${wistiaId}`;
      return (
        <div className={`video-embed-container ${className}`}>
          <iframe
            title={title}
            src={embedUrl}
            style={{ border: 0 }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }
  }

  return (
    <div className={`video-embed-container ${className}`}>
      <iframe
        title={title}
        src={normalizedVideoUrl}
        style={{ border: 0 }}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default VideoPlayer;
